import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { cjNav, cjFeed, FEEDS } from "../../lib/cj";
import { MarketRail } from "../../components/market/MarketRail";

const MarketHome = () => {
  const [nav, setNav] = useState([]);
  const [feeds, setFeeds] = useState({});

  useEffect(() => {
    cjNav().then((d) => setNav(d.collections || [])).catch(() => {});
    FEEDS.forEach(({ key }) => {
      cjFeed(key, 12).then((d) => setFeeds((prev) => ({ ...prev, [key]: d.products || [] }))).catch(() => {});
    });
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-8" data-testid="market-home">
      <div className="mb-8">
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-taven-gold">TAVEN Marketplace</p>
        <h1 className="text-3xl md:text-5xl font-black font-display tracking-tighter mt-1">Shop Everything</h1>
        <p className="text-sm text-muted-foreground mt-2 max-w-2xl">Curated, quality-checked products with fast US shipping and honest pricing.</p>
      </div>

      {/* Category navigation */}
      <div className="flex flex-wrap gap-2 mb-10" data-testid="market-category-nav">
        {nav.map((c) => (
          <Link key={c.handle} to={`/market/collection/${c.handle}`}
            className="px-4 py-2 rounded-full bg-taven-gray text-xs font-semibold hover:bg-black hover:text-white transition-colors">
            {c.name}
          </Link>
        ))}
      </div>

      {/* Merchandising rails */}
      {FEEDS.map(({ key, label }) => (
        <MarketRail key={key} title={label} products={feeds[key] || []}
          accent={key === "flash-deals"}
          viewAllTo={key === "flash-deals" ? undefined : "/market/search"} />
      ))}
    </div>
  );
};

export default MarketHome;
